import DPlayer from 'dplayer'
import HLS from 'hls.js'
window.Hls = HLS

export default {
  name: 'Video',

  props: {
    options: {
      type: Object
    },
  },
  data:() => ({
    player:null,
  }),
  mounted() {
    let data = {
      ...(this.options || {}),
      container:this.$el
    }
    const player = this.dp = new DPlayer(data)
    const events = player.events
    Object.keys(events).forEach(item => {
      if (item === 'events') {
        return false
      } else {
        events[item].forEach(event => {
          player.on(event, () => this.$emit(event))
        })
      }
    })
    this.player = player
    this.$emit('ready' , player)
  },
  beforeDestroy() {
    if( this.player ){
      this.player.destroy()
    }
  },
  render() {
    return <div style="width:100%;height:100%;object-fit: contain;" class="dplayer"></div>
  }
}